// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  height: 18px;
  width: 18px;
  padding-top: 4px;
}
@media (min-width: 991px) {
  ion-icon {
    height: 22px;
    width: 33px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,WAAA;EACA,gBAAA;AADD;ACHE;EDCF;IAKE,YAAA;IACA,WAAA;EACA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\nion-icon {\n\theight: 18px;\n\twidth: 18px;\n\tpadding-top: 4px;\n\t@include desktop {\n\t\theight: 22px;\n\t\twidth: 33px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
